import { call, put } from 'redux-saga/effects';
import { apiGeneral, notify } from 'services';
import { IUpdateRequest } from 'interfaces/update-duck';
import { requestErrorHandler } from 'utils';
import { DeleteGroupPermissionActions } from 'store/ducks/settings/group-permissions';

export function* deleteGroupPermissionRequest(action: any) {
  try {
    const { id, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.delete,
      `/group-permission/${id}`
    );

    const { data } = responseBody;
    yield put(DeleteGroupPermissionActions.success(data));
    notify('success', 'Permissão do Grupo removido com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(DeleteGroupPermissionActions.failure(errorMessage));
  }
}
